import React, { useRef, useMemo } from 'react'
import { DetailStoreProvider } from '@vt/hooks'
import Log from './index'

export default () => {
  const modalRef = useRef()

  const open = (data) => {
    if (modalRef.current) {
      modalRef.current.open(data)
    }
  }

  const close = () => {
    if (modalRef.current) {
      modalRef.current.close()
    }
  }

  const LogModalRender = useMemo(() => {
    return (
      <DetailStoreProvider>
        <Log ref={modalRef} />
      </DetailStoreProvider>
    )
  }, [modalRef])

  return {
    open,
    close,
    LogModalRender,
  }
}
